import { lazy } from 'react';

import { isUserLoggedIn, getUserData } from '@utils';
import { AccessControl } from '@src/views/AccessControl';
import { TermsServiceElohe } from '@src/views/pages/TermsServiceElohe';

import { Register } from '../../views/Register';
import { Login } from '../../views/Login';
import { TwoFactorAuthentication } from '../../views/TwoFactorAuthentication';
import { Dashboards } from './Dashboards';
import { Pages } from './Pages';

// ** Document title
const TemplateTitle = '%s - Vuexy React Admin Template';

// ** Default Route
const DefaultRoute =
  isUserLoggedIn() && getUserData().role === 'operator'
    ? '/dashboard/simulator'
    : '/dashboard/ecommerce';

const publicRoutes = [
  {
    path: '/onboarding/company/register',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/RegisterOnboarding')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/onboarding/company/welcome',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/StartOnboarding')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/onboarding/company/finished',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/CompanyIntegration/FinishedPag')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/onboarding/company/tokenInvalidPage',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/TokenInvalidPage')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/onboarding/company/wizard',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/CompanyIntegration')
    ),
    layout: 'BlankLayout',
    /* meta: {
    action: 'view_registration_wizard',
    resource: 'ACL',
  }, */
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/access-control',
    component: AccessControl,
    meta: {
      action: 'read',
      resource: 'ACL',
    },
  },
  {
    path: '/login',
    component: Login,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/pre-register',
    component: lazy(() => import('../../views/PreRegister')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/auth',
    component: TwoFactorAuthentication,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/send-code-whatsapp',
    component: lazy(() =>
      import('../../views/TwoFactorAuthentication/TwoFASendCodeWhatsApp')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/forgot-password',
    component: lazy(() =>
      import('../../views/pages/authentication/ForgotPassword')
    ),
    exact: true,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/forgot-password/completed',
    component: lazy(() =>
      import('../../views/pages/authentication/ForgotPasswordCompleted')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/forgot-password-whatsapp/completed',
    component: lazy(() =>
      import('../../views/pages/authentication/ForgotPasswordCompletedWhatsApp')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/reset-password',
    component: lazy(() =>
      import('../../views/pages/authentication/ResetPassword')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/register',
    component: Register,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/checkout/finish',
    component: lazy(() => import('../../views/pages/CheckoutFinish')),
    exact: true,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/checkout/payed',
    component: lazy(() => import('../../views/pages/CheckoutPayed')),
    exact: true,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/checkout/:id',
    component: lazy(() => import('../../views/pages/Checkout')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/error',
    component: lazy(() => import('../../views/Error')),
    layout: 'BlankLayout',
  },
  {
    path: '/terms/:termId',
    component: TermsServiceElohe,
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
  {
    path: '/contract/service',
    component: lazy(() => import('../../views/pages/ContractService')),
    layout: 'BlankLayout',
    meta: {
      authRoute: true,
    },
  },
];

// ** Merge Routes
const Routes = [...Dashboards, ...Pages, ...publicRoutes];

export { DefaultRoute, TemplateTitle, Routes, publicRoutes };
